<template>
    <div class="myorder">
        <van-nav-bar :title="title" left-text="" @click-left="onClickLeft" left-arrow
                     :fixed="true">
        </van-nav-bar>
        <div class="mo-tab">
            <van-tabs v-model="active" @click="checkedTab">
                <van-tab title="待支付">
                </van-tab>
                <!--                <van-tab title="待拼团">-->
                <!--                </van-tab>-->
                <van-tab title="已完成">
                </van-tab>
                <van-tab title="全部">
                </van-tab>
            </van-tabs>
            <div>
                <van-list
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        @load="getOrderList"
                >
                    <div class="myo-item" v-for="item in list">
                        <van-panel :title="deptName" :desc="'订单号: '+item.orderNo"
                                   :status="map[item.orderStatus]" :border="false" @click="toOrderInfo(item)">
                            <span class="leixing" v-if="item.orderType==1">普通商品</span>
                            <span class="leixing" v-if="item.orderType==2">PLUS商品</span>
                            <span class="leixing" v-if="item.orderType==4">秒杀商品</span>
                            <div class="myo-skuinfo" v-for="sku in item.spus">
                                <img :src="sku.imgUrl" class="sku-img"/>
                                <div class="myo-name">
                                    <span style="font-size: 12px">{{sku.itemName}}</span>
                                    <span style="font-size: 10px;color: #888888;margin-top: -10px" v-if="sku.specs">{{sku.specs}}</span>
                                    <span style="font-size: 13px;color: #ff4d51">¥{{sku.skuPrice}}</span>
                                </div>
                                <span style="font-size: 11px;width: 50px;text-align: right">
                                    x{{sku.skuNum}}
                                </span>
                            </div>
                        </van-panel>
                        <div class="myo-btn">
                            <span class="myo-sp-btn1" style="margin-right: 12px" v-if="item.orderStatus==0"
                                  @click="delOrder(item.id)">取消订单</span>
                            <span class="myo-sp-btn" v-if="item.orderStatus==0" @click="toOrderInfo(item)">去支付</span>
                        </div>
                    </div>
                </van-list>
            </div>
        </div>
    </div>
</template>

<script>
    import {getCookie, getDeptId, getDeptName,} from "../../utils/auth";

    export default {
        data() {
            return {
                title: '我的订单',
                active: 0,
                deptId: '',
                deptName: '',
                token: '',
                map: {
                    '0': '待付款',
                    '3': '已完成',
                },
                params: {},

                list: [],
                loading: false,
                finished: false,
                page: 1,
            };
        },
        async created() {
            document.title = getDeptName()
            this.active = parseInt(this.$route.params.active)
            this.deptId = getDeptId()
            this.token = getCookie('spmToken')
        },
        methods: {
            checkedTab() {
                this.list = []
                this.page = 1
                this.getOrderList()
            },

            async getOrderList() {
                let orderStatus = 0
                if (this.active == 0) {
                    orderStatus = 0;
                }
                if (this.active == 1) {
                    orderStatus = 3;
                }
                if (this.active == 2) {
                    orderStatus = '';
                }
                let data = {
                    orderStatus: orderStatus,
                    shippingType: '0',
                    token: this.token,
                    currentPage: this.page
                }
                let res = await this.$get("/spm/getSpmOrderForPage", data)
                if (res.code == 200) {
                    const count =res.dataSet.list.length
                    const newList =res.dataSet.list
                    const list =this.list.concat(newList)
                    if (list.length<30){
                        this.list = this.quchong(list,"id")
                    }else {
                        this.list =list
                    }
                    this.page=this.page+1
                    this.loading = false
                    if (count<10&&count==0){
                        this.finished = true
                    }
                }else {
                    this.finished = true
                }
                this.deptName = res.deptName
            },

            //订单详情
            toOrderInfo(item) {
                if (item.orderType == 1) {
                    this.$router.push('/ztptDetails/' + this.deptId + '/' + item.id)
                } else {
                    this.$router.push('/ztGoodsDetails/' + this.deptId + '/' + item.id)
                }

            },

            onClickLeft() {
                if (window.history.length > 1) {
                    this.$router.back();
                } else {
                    this.$router.push('/home/' + this.deptId)
                }
            },

            //删除订单
            async delOrder(orderId) {
                this.$dialog.confirm({
                    title: '操作',
                    message: '是否取消订单？'
                }).then(async () => {
                    let data = {
                        orderId: orderId
                    }
                    let res = await this.$post("/spm/delSpmOrder", data)
                    if (res.code == 200) {
                        this.$notify({
                            message: res.message,
                            duration: 1000,
                            background: '#1989fa'
                        });
                        this.getOrderList()
                    } else {
                        this.$notify({
                            message: res.message,
                            duration: 1000,
                            background: 'red'
                        });
                    }
                }).catch(() => {
                    console.log("取消")
                });
            },

            //确认收货
            async updateOrder(orderId) {
                this.$dialog.confirm({
                    title: '操作',
                    message: '是否确认收货？'
                }).then(async () => {
                    let data = {
                        id: orderId,
                        orderStatus: "3",
                    }
                    let res = await this.$post("/spm/updateSpmOrder", data)
                    if (res.code == 200) {
                        this.$notify({
                            message: res.message,
                            duration: 1000,
                            background: '#1989fa'
                        });
                        this.getOrderList()
                    } else {
                        this.$notify({
                            message: res.message,
                            duration: 1000,
                            background: 'red'
                        });
                    }
                }).catch(() => {
                    console.log("取消")
                });
            },

            //退款
            refund(orderId) {
                this.$dialog.confirm({
                    title: '操作',
                    message: '是否退款？？'
                }).then(async () => {
                    let data = {
                        orderId: orderId,
                        orderStatus: "3",
                    }
                    let res = await this.$post("/api/refundOrder", data)
                    if (res.code == 200) {
                        this.$notify({
                            message: res.message,
                            duration: 1000,
                            background: '#1989fa'
                        });
                        this.getOrderList()
                    } else {
                        this.$notify({
                            message: res.message,
                            duration: 1000,
                            background: 'red'
                        });
                    }
                }).catch(() => {
                    console.log("取消")
                });
            },

            async zhifu(orderId) {
                // this.$toast.loading({
                //     mask: true,
                //     message: '加载中...',
                //     duration: 0,
                // });
                let res = await this.$post('/api/unifiedOrder', {
                    orderId: orderId
                })
                // this.$toast.clear
                this.params = res
                if (typeof WeixinJSBridge === 'undefined') {
                    if (document.addEventListener) {
                        document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady(this.params), false)
                    } else if (document.attachEvent) {
                        document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady(this.params))
                        document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady(this.params))
                    }
                } else {
                    this.onBridgeReady(this.params)
                }
            },

            onBridgeReady(params) {
                const that = this
                WeixinJSBridge.invoke(
                    'getBrandWCPayRequest',
                    {
                        appId: params.appId, // 公众号名称，由商户传入
                        timeStamp: params.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                        nonceStr: params.nonceStr, // 支付签名随机串，不长于 32 位
                        package: params.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                        signType: params.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
                        paySign: params.paySign // 支付签名
                    },
                    function (res) {
                        if (res.err_msg == 'get_brand_wcpay_request:ok') {
                            that.$router.push('/success/' + this.deptId)
                        }
                        if (res.err_msg == 'get_brand_wcpay_request:fail') {
                            that.$notify({
                                message: '支付失败',
                                duration: 1000,
                                background: 'red'
                            });
                        }
                    }
                )
            },
        },
    };
</script>

<style lang="scss" scoped>

    .myorder {
        padding-top: 46px;
        padding-bottom: 50px;
        overflow: scroll;
        background-color: #EEEEEE;
        height: 100%;
    }

    .mo-tab {

    }

    ::v-deep .van-nav-bar__title {
        max-width: 60%;
        margin: 0 auto;
        color: #323233;
        font-weight: 500;
        font-size: 15px;
    }

    .van-cell {
        position: relative;
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        box-sizing: border-box;
        width: 100%;
        padding: 0.2rem 0.45rem;
        overflow: hidden;
        color: #323233;
        font-size: 0.37333rem;
        line-height: 0.64rem;
        background-color: #fff;
    }

    .van-cell__title span {
        font-size: 12px;
    }

    .van-panel__header-value {
        font-size: 12px;
    }

    .van-cell__label {
        margin-top: 0px;
        color: #969799;
        font-size: 11px;
        line-height: 0.4rem;
    }

    .myo-item {
        width: 98%;
        margin: auto;
        margin-top: 5px;
        border-radius: 5px;
        padding: 3px;
        background-color: #FFFFFF;
        padding-bottom: 12px;
    }

    .myo-skuinfo {
        display: flex;
        flex-direction: row;
        width: 90%;
        margin: auto;
        margin-top: 8px;
        padding: 6px 10px;
        border: #F5F6F7 solid 1px;
        border-radius: 8px;
        background-color: #FAFAFA;
    }

    .sku-img {
        width: 55px;
        height: 55px;
    }

    .myo-name {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin-left: 8px;
        width: 80%;
    }

    .myo-btn {
        display: block;
        text-align: right;
        padding-right: 16px;
        height: 30px;
        margin-top: 12px;
    }

    .myo-sp-btn {
        width: 50px;
        font-size: 10px;
        border: #FF4444 solid 1px;
        padding: 1px 12px;
        border-radius: 15px;
        color: #FF4444;
        position: relative;
        bottom: 12px;
    }

    .myo-sp-btn1 {
        width: 50px;
        font-size: 10px;
        border: #BBBBBB solid 1px;
        padding: 1px 12px;
        border-radius: 15px;
        color: #000000;
        position: relative;
        bottom: 12px;
    }

    .leixing {
        display: block;
        text-align: right;
        position: relative;
        font-size: 10px;
        top: -20px;
        padding: 0 0.45rem;
    }
</style>
